const FETCH_COUNT_PAGE_SUCCESS = 'FETCH_COUNT_PAGE_SUCCESS';

const defaultState = {
    countPage: 1,
    total: 0
};

export default function countPageReducer(state = defaultState, action) {
    switch (action.type) {
        case FETCH_COUNT_PAGE_SUCCESS:
            return {
                countPage: action.payload.totalPages,
                total: action.payload.total
            }
        default:
            return state
    }
}